import ActionButton from '@/common/components/buttons/ActionButton';
import { getTrackingLinkV2 } from '@/common/functions/getTrackingLinkV2';
import { Colors } from 'chart.js';
import moment from 'moment';

export const getQueueGuessingRows = (data, posts) => {
	const postsMap = posts.reduce((acc, post) => {
		if (post._id) {
			acc[post._id] = post;
		}
		if (post.curier_name) {
			acc[post.curier_name] = post;
		}
		return acc;
	}, {});

	const rows = data.map((d, i) => {
		const courierNameFromPost = postsMap[d.curierName || d.curierId];

		return (
			<tr key={i}>
				<td>{i + 1}.</td>
				<td>{d.fullName}</td>
				<td>{d.email}</td>
				<td>{d?.waybill}</td>
				<td>{d?.paxyInternalNumber || '-------'}</td>
				<td>{d?.status}</td>
				<td>{d?.lmsSentDate && moment(d?.lmsSentDate).format('DD/MM/YYYY')}</td>
				<td>
					{d?.deliveredNoPaymentDate &&
						moment(d?.deliveredNoPaymentDate).format('DD/MM/YYYY')}
				</td>
				<td>{courierNameFromPost?.name}</td>
				<td>{courierNameFromPost?.provider}</td>
				<td>
					<div style={{ display: 'flex', gap: '10px' }}>
						<ActionButton
							style={{ fontSize: '12px' }}
							color={Colors.blue}
							onClick={(e) => {
								window.open(`/dashboard/order/${d._id}`, '_blank');
							}}
							defaultText='Show Order'
						/>
						<ActionButton
							style={{ fontSize: '12px' }}
							onClick={() => {
								window.open(
									getTrackingLinkV2(
										d.country,
										{
											tracking_link: d.trackingLink,
											waybill_number: d.waybill,
											curier_name: d.curierName,
											curierId: d.curierId,
										},
										posts,
									),
									'_blank',
								);
							}}
							defaultText='Check Post'
							color='#000'
						/>
					</div>
				</td>
			</tr>
		);
	});

	return rows;
};
